export default __webpack_public_path__ + "static/media/welcome-male@3x.8176e7d2.png";